
import type { SVGProps } from 'react';
const SvgContact = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#contact_svg__a)">
      <path
        fill="#263E6A"
        d="M8.747 21.81q-.12 0-.24-.025l-.367-.075a1.3 1.3 0 0 1-1.013-1.291l.135-3.59c.02-.514.324-1.2.693-1.559l6.23-6.074-7.5 5.117c-.46.313-1.202.35-1.691.084l-3.535-1.925c-.3-.163-.467-.41-.459-.678s.19-.504.5-.649l2.35-1.098a.35.35 0 0 1 .296.634l-2.35 1.098a1 1 0 0 0-.066.037 1 1 0 0 0 .063.041l3.535 1.925c.26.142.72.119.963-.048l10.17-6.938c.2-.135.531-.362.76-.083s-.06.56-.232.727l-8.545 8.331c-.244.238-.47.745-.482 1.085l-.136 3.59a.605.605 0 0 0 .455.578l.367.076a.605.605 0 0 0 .644-.354l1.095-2.865a1.075 1.075 0 0 1 1.459-.6l4.795 2.173a.3.3 0 0 0 .262.008.3.3 0 0 0 .157-.21l4.226-16.55.008-.036-.034.015L6.74 9.468a.35.35 0 1 1-.296-.634l14.52-6.787c.313-.147.609-.133.813.036s.272.458.187.792l-4.227 16.55c-.076.3-.27.542-.532.668a1 1 0 0 1-.853-.002l-4.795-2.173a.38.38 0 0 0-.306-.008.38.38 0 0 0-.21.22l-1.095 2.866a1.3 1.3 0 0 1-1.2.814"
      />
    </g>
    <defs>
      <clipPath id="contact_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgContact;
